__turbopack_context__.v({
  "container": "hli7VW_container",
  "description": "hli7VW_description",
  "descriptionTariff": "hli7VW_descriptionTariff",
  "footer": "hli7VW_footer",
  "footerDescription": "hli7VW_footerDescription",
  "groupResult": "hli7VW_groupResult",
  "header": "hli7VW_header",
  "helpIcon": "hli7VW_helpIcon",
  "hideLg": "hli7VW_hideLg",
  "list": "hli7VW_list",
  "mktuLink": "hli7VW_mktuLink",
  "price": "hli7VW_price",
  "result": "hli7VW_result",
  "row": "hli7VW_row",
  "secondary": "hli7VW_secondary",
  "title": "hli7VW_title",
});
